export default __webpack_public_path__ + "static/media/Question.a672bb95.m4a";